import { render } from "./ViewReclamationPage.vue?vue&type=template&id=ea2c7eda&ts=true"
import script from "./ViewReclamationPage.vue?vue&type=script&lang=ts"
export * from "./ViewReclamationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__